export default function(element) {
  if (!element) {
    console.warn(`Cannot print. The element is null.`);
    return;
  }

  element = element.$el || element;
  const parent = element.parentElement;
  document.body.appendChild(element);

  try {
    element.classList.add('print-body');
    window.print();
    console.log(`Done printing!`);
  } catch (error) {
    console.error('Could not print element', error);
  } finally {
    document.body.removeChild(element);
    parent.appendChild(element);
    element.classList.remove('print-body');
  }
}
